import React from "react";
import { FaFacebookF, FaGoogle, FaInstagram, FaTwitter } from "react-icons/fa";
import "./Footer.css";
import logo from "../../Assets/logoja.png";
import { CiHome, CiPhone } from "react-icons/ci";
import { MdAlternateEmail } from "react-icons/md";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <div className="footer">
        <div className="footer-socialicons">
          <span id="span-lart">Get connected with us on social networks:</span>
          <div className="icons">
            {" "}
            <a target="_blank" href="https://www.facebook.com">
              {" "}
              <FaFacebookF />{" "}
            </a>
            <a target="_blank" href="https://www.twitter.com">
              <FaTwitter />
            </a>
            <a
              target="_blank"
              href="https://www.instagram.com/dritansbarbershop"
            >
              <FaInstagram />
            </a>
            <a target="_blank" href="https://www.google.com">
              <FaGoogle />
            </a>
          </div>
        </div>
        <div className="footer-content">
          <img src={logo} alt="" />
          <div className="footer-card">
            <h3>Barber Shop</h3>
            <p>
              Here you can use rows and columns to organize your footer content.
              Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            </p>
          </div>
          <div className="footer-card">
            <h3>Services</h3>
            <span>Haircuts</span>
            <span>Beard Trimming</span>
            <span>Professional Hairstyling</span>
            <span>Shaving</span>
          </div>
          <div className="footer-card">
            <h3>Explore</h3>
            <span><a href="#faqja-home">Home</a></span>
            <span><Link to="/about">About Us</Link></span>
            <span><Link to="/services">Services</Link></span>
            <span><Link to="/contact">Contact</Link></span>
          </div>
          <div className="footer-card">
            <h3>Contact Us</h3>
            <span className="span-ikonat">
              <a href="mailto:info@barbershop.com">
                <MdAlternateEmail />
                info@barbershop.com
              </a>
            </span>
            <span className="span-ikonat">
              <a href="tel:+1234567890">
                <CiPhone />
                +123 456 7890
              </a>
            </span>
            <span className="span-ikonat">
              <a
                href="https://www.google.com/maps/place/123+Main+Street,+City,+Country"
                target="_blank"
                rel="noopener noreferrer"
              >
                <CiHome />
                123 Main Street, City, Country
              </a>
            </span>
            <span className="span-ikonat">
              <a
                href="https://www.instagram.com/barbershop"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
                @barbershop
              </a>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
